//import React, {Suspense} from 'react'
import React, { useEffect, useState, useMemo, Suspense } from "react";
import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from '../smallnation/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../smallnation/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import { Routes } from './routing/Routes'
import services from "./modules/services/services"
import { ReactKeycloakProvider } from '@react-keycloak/web';
//import { useKeycloak } from '@react-keycloak/web';
import Keycloak from 'keycloak-js';
import $ from 'jquery';
//import { useSearchParams, useLocation, useHistory } from "react-router-dom";
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import { useParams, useLocation, useHistory } from "react-router-dom";
import jwt from 'jwt-decode' // import dependency
//import { useNavigate,useParams } from "react-router-dom";

type Props = {
  basename: string
}









const App: React.FC<Props> = ({ basename }) => {

  //const navigate = useNavigate();
  /*
  const keycloak = new Keycloak({
    //url: "http://keycloak-dotstow-dev-alb-1135353619.us-east-2.elb.amazonaws.com/auth",
    url:process.env.React_App_KEYCLOAK_URL,
    //realm: "SNV3",
    realm: process.env.React_App_REALM,
    clientId: "snv3_ui",
    post_logout_redirect_uri:"/"
    
  });
  */
  const keycloak = new (Keycloak as any)({
    //url: "http://keycloak-dotstow-dev-alb-1135353619.us-east-2.elb.amazonaws.com/auth",
    url: process.env.React_App_KEYCLOAK_URL,
    //realm: "SNV3",
    realm: process.env.React_App_REALM,
    clientId: "snv3_ui",
    post_logout_redirect_uri: "/"

  });


  // let history = useHistory();
  //  const locationHome = useLocation();
  //  const queryParamsHome = new URLSearchParams(locationHome.search);
  //  const actionHome = queryParamsHome.get('action');
  // const actionHome = "test";
  /*
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const loginRedirectVal = queryParams.get('loginRedirect');
  const loginResetVal = queryParams.get('loginReset');
  */

  function checkArray(needle: any, haystack: any) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
      if (haystack[i] == needle) return true;
    }
    return false;
  }


  //const initOptions = { pkceMethod: 'S256' }
  const handleOnEvent = async (event: any, error: any) => {
    /*
    let history = useHistory();
    const locationHome = useLocation();
    const queryParamsHome = new URLSearchParams(locationHome.search);
    const actionHome = queryParamsHome.get('action');
    alert(actionHome);
  */
    //const loginRedirectVal = "2";


    if (event === 'onAuthSuccess') {

      if (keycloak.authenticated) {
        //let response = await moviesApi.getUserExtrasMe(keycloak.token)
        if (keycloak.token != "") {

          // sessionStorage.setItem("adminAccToken",keycloak.token);



          var logObj: any = jwt(keycloak.token);
          var logObjStr = JSON.stringify(logObj);
          //sessionStorage.setItem("logObj",logObjStr); 
          var lobObjVal = eval(logObj);
          keycloak.authenticated = true;
          //alert(lobObjVal.resource_access.snv3_app.roles);
          //alert(typeof(lobObjVal.resource_access.snv3_app.roles));
          if (lobObjVal.resource_access.snv3_app.roles) {
            var roleAr = lobObjVal.resource_access.snv3_app.roles;
          } else {
            var roleAr: any = [];
          }

          //alert(roleAr);
          if (checkArray("siteadmin", roleAr) || checkArray("siteAdmin", roleAr) || roleAr == "sitadmin") {
            sessionStorage.setItem("adminAccToken", keycloak.token);
          } else {
            //alert("test");
            //window.location.href = process.env.React_App_PUBLIC_URL;
            var url_to: any = process.env.React_App_PUBLIC_URL;
            window.location.href = url_to;
            //keycloak.logout()
          }

          //$('#loginCall').trigger('click');
        }
        // if (response.status === 404) {
        //   const userExtra = { avatar: keycloak.tokenParsed.preferred_username }
        //   response = await moviesApi.saveUserExtrasMe(keycloak.token, userExtra)
        //   console.log('UserExtra created for ' + keycloak.tokenParsed.preferred_username)
        // }
        // keycloak['avatar'] = response.data.avatar
      } else {
        //alert("test");
        //window.location.href="/login";
      }
    } else if (event == "onReady") {

      if (keycloak.authenticated) {
        const accessTokenTo = sessionStorage.getItem("adminAccToken");

        if (accessTokenTo !== "") {
          // accountType();  
          // navigate('/dashboard');

        }
        $("#kt_aside").show();

      } else {
        //alert("140") 
        // navigate('/login');
        $("#kt_aside").hide();
        keycloak.login();
      }

    }
  }


  function getCheckSess() {

    const requestObject =
    {

    }


    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + accessTokenIn
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };


    var resp = services.adminVerify(requestOptions);
    // alert("---->"+resp); 
    /*
        services.applicationlistbycompanyChk(requestOptions).then((res) => 
        {
           
            console.log("from 180--"+res);
        });
        */

  }


  const handleLogout = () => {
    sessionStorage.clear();
    //alert("144");
    var logoutOptions = { redirectUri: "http://localhost:3001/" };
    //keycloak.logout(logoutOptions);



    keycloak.logout().then((success: any) => {
      console.log("--> log: logout success ", success);
      // alert("test");
      keycloak.authenticated = false;
      window.location.replace("/dashboard");
    }).catch((error: any) => {
      alert(error);
      console.log("--> log: logout error ", error);
    });


    //keycloak.logout();
    //keycloak.authenticated = false;
    //window.location.replace("/Home");
    //setTimeout(function() {window.location.replace("/");}, 2000);
    //window.location.replace("/Home?loginRedirect=1");
    //handleLogin();
    //window.location.replace("/");
    //setTimeout(function() {window.location.replace("/thankyou");}, 2000);
    //window.location.replace("/Home");
    //window.location.href = "/thankyou";
  }
  const handleLogoutMain = () => {
    // alert("test");
    // let history = useHistory();
    // history.push('/?action=logout');
    //keycloak.logout();
    //keycloak.logout({ redirectUri: "/dashboard" });
    window.location.href = "/";


    // window.location.href="/?action=logout";
    // sessionStorage.clear();  

    //keycloak.logout();      
    //keycloak.authenticated = false;


    // window.location.replace("/Home");
    //window.location.replace("/Home?loginRedirect=1");
    //handleLogin();
    //window.location.replace("/");
    //setTimeout(function() {window.location.replace("/thankyou");}, 2000);
    //window.location.replace("/Home");
    //window.location.href = "/thankyou";
  }

  useEffect(() => {
    $("#kt_aside").hide();
    // getCheckSess();
    setInterval(getCheckSess, 1800000);

    // alert("test");
    //alert(JSON.stringify(keycloak))
    /*
    if (keycloak.authenticated) {
     $("#kt_aside").show();
    }else{
     $("#kt_aside").show();
    }
    */

    const pathName = window.location.pathname;
    //alert(pathName);
    /*
    if(pathName == "/logoutAction"){
     //sessionStorage.clear();
     //keycloak.logout(); 
     //alert("test"); 
     handleLogout();
     return;
    }
    */


    //alert(loginRedirectVal);


  }, []);


  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      onEvent={(event, error) => handleOnEvent(event, error)}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <BrowserRouter basename={basename}>
          <I18nProvider>
            <LayoutProvider>
              <AuthInit>
                <Routes />
              </AuthInit>
            </LayoutProvider>
          </I18nProvider>
        </BrowserRouter>
      </Suspense>
    </ReactKeycloakProvider>
  )
}

export { App }
